import {
    validators,
    checkNumberList,
    checkEmailList,
} from '../../utils/validators';
import { isEmpty } from 'lodash';

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};
    if (REQUIRED(values.remarks)) {
        errors.remarks = 'Please enter Remarks';
    }
    if (REQUIRED(values.linkName)) {
        errors.linkName = 'Please enter LinkName';
    }
    if (isEmpty(values.sharebysms) && isEmpty(values.sharebyemail)) {
        errors.sharebyemail = 'Please enter the Emails and Phone Numbers';
    }

    if (checkNumberList(values.sharebysms)) {
        errors.sharebysms = 'Please enter valid mobile numbers';
    }
    if (checkEmailList(values.sharebyemail)) {
        errors.sharebyemail = 'Please enter valid emails';
    }
    return errors;
};

export default validate;
